/**
 * Nest `/v1` API config (Phase 12 — Nest-only client).
 *
 * Local dev: prefer `REACT_APP_AUTH_URL=/v1` so the browser stays same-origin and
 * `src/setupProxy.js` forwards to `REACT_APP_DEV_API_TARGET` (never production by default).
 * Production builds must set an absolute `REACT_APP_AUTH_URL` (or `REACT_APP_API_BASE_URL`).
 */

function resolveAuthUrl(): string {
    const fromEnv = (process.env.REACT_APP_AUTH_URL || process.env.REACT_APP_API_BASE_URL || '').trim();
    const isProd = process.env.NODE_ENV === 'production';

    if (isProd) {
        if (!fromEnv) {
            throw new Error(
                'Missing REACT_APP_AUTH_URL (or REACT_APP_API_BASE_URL). Production builds must set an absolute Nest /v1 API base URL.'
            );
        }
        if (fromEnv.startsWith('/')) {
            throw new Error('REACT_APP_AUTH_URL must be an absolute URL in production (relative /v1 is only for local CRA proxy).');
        }
        return fromEnv.replace(/\/$/, '');
    }

    // Development: default to same-origin /v1 (setupProxy). Absolute URLs still allowed.
    return (fromEnv || '/v1').replace(/\/$/, '');
}

export const authURL = resolveAuthUrl();
/** Alias for the Nest base (same as authURL). */
export const apiBaseURL = authURL;
